var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_160_938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.06805 18H19.724C20.2059 18 20.6806 17.884 21.1081 17.6617C21.5356 17.4394 21.9033 17.1174 22.18 16.723C22.4567 16.3285 22.6344 15.8732 22.6979 15.3956C22.7615 14.918 22.709 14.4321 22.545 13.979L19.693 6.094C19.206 4.34171 18.1583 2.79719 16.7104 1.69667C15.2624 0.59615 13.4938 0.000212078 11.675 1.01731e-09C9.78177 -2.95923e-05 7.9451 0.645588 6.46826 1.83026C4.99142 3.01493 3.96274 4.66781 3.55205 6.516L1.20205 14.116C1.06369 14.5647 1.03258 15.0396 1.11124 15.5025C1.18989 15.9654 1.37611 16.4034 1.6549 16.7812C1.93369 17.1591 2.29728 17.4662 2.71641 17.6779C3.13554 17.8895 3.5985 17.9999 4.06805 18Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.09998 20C7.32949 21.1303 7.94271 22.1465 8.83572 22.8764C9.72873 23.6063 10.8466 24.005 12 24.005C13.1533 24.005 14.2712 23.6063 15.1642 22.8764C16.0572 22.1465 16.6705 21.1303 16.9 20H7.09998Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_160_938"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRing);
export default __webpack_public_path__ + "static/media/ring.490111db02df2a2dce2a559b31633de6.svg";
export { ForwardRef as ReactComponent };